<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="favoriteElectricList.length>0">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">常用電號</span>
        </div>
        <div>
          <span style="font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</span>
        </div>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in favoriteElectricList" :key="i" class="flex border">
          <div>
            <div style="font-size: 14px; color: #c7c7c7">{{ item.electricity_name }}</div>
            <div>{{ formatElectricNumber(item.electricity_number) }}</div>
          </div>
          <div class="delete" v-if="isListInModify" @click="removeFavoriteElectricNumber(item.electricity_number_serial_number)"></div>
          <div class="active" v-else @click="getBillIsNull(false, item.electricity_name, item.electricity_number)">查詢</div>
        </div>
      </div>
    </div>
    <div class="bg-white padding">
      <div class="input-item flex">
        <div style="display: flex; align-items: center" class="text-nowrap">
          <div class="line"></div>
          {{ favoriteElectricList.length>0 ? '查詢其他電號' : '請輸入帳單資訊' }}
        </div>
        <div class="icon-scan" @click="openScanner()">掃描</div>
      </div>
      <div class="form">
        <div>
          <div class="field">            
            戶名
          </div>
          <input type="text" name="electric_name" placeholder="請輸入戶名" class="input" v-model="form.electricName" @focus="electricNameInFocus = true" @keyup="changeElectricName" @blur="electricNameInFocus = false" />
          <div class="border-bottom" :style="branchBorderStyle"></div>
        </div>
        <div>
          <div class="field">
            電號(11碼)
          </div>
          <input type="text" name="electric_number" placeholder="00 00 0000 00 0" class="input" v-model="formatedElectricNumber" @focus="electricNumberInFocus = true" @keyup="changeElectricNumber" @blur="electricNumberInFocus = false" />
          <div class="border-bottom"></div>
        </div>      
        <div class="agree-label" style="margin-bottom: 16pt">
            <input type="checkbox" id="isAddFavroriteChecked" v-model="isAddFavroriteChecked">
            <label for="isAddFavroriteChecked">加入常用電號</label>
        </div>
      </div>
      <button class="btn btn-primary" :disabled="isSearchBtnDisable" ref="search_btn" @click="addFavoriteElectricNumber">查詢待繳帳單</button>
    </div>
    <div class="padding description">
      <ul class="text-gray2">    
        <li>繳費後無法取消，若需退費請洽台電24小時客服專線1911。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
        <li>若已設定於金融機構自動扣繳電費，請勿重複繳費。</li>      
        <li>倘有繳付接電費，後續台電將會盡快完成復電作業，請勿擅動用電設備，以維用電安全</li>
        <li>倘有繳付接電費，手機號碼僅供台電作為復電相關事項聯絡使用，不另作其他用途。</li>
      </ul>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>

<script>
import { saveFavoriteElectricNumber, queryFavoriteElectricNumber, deleteFavoriteElectricNumber, queryBillList } from '../../api/api';
import { mapActions } from 'vuex';

export default {
  name: 'new-electric',
  data() {
    return {
      favoriteElectricList: [],
      isListInModify: false,
      form: {
        electricNumber: '',
        electricName: '',
        qrCode: '',
      },
      isAddFavroriteChecked: true,     
      electricNameInFocus: false, 
      electricNumberInFocus: false,
    };
  },
  created() {
    this.getFavoriteElectrics();
    window.getScanningResult = this.getScanningResult;
  },
  computed: {
    formatedElectricNumber: {
      get() {
        return this.formatElectricNumber(this.form.electricNumber);
      },
      set(value) {
        // just placeholder as we dont have Vuex here
        this.form.electricNumber = value.trim().replace(/ /g, '');
      }

    },
    isSearchBtnDisable() {
      return this.form.electricName === '' || this.form.electricNumber === '';
    },    
  },
  watch: {
    isSearchBtnDisable() {
      this.changeElectricNumber();
    }
  }, 
  methods: {
    ...mapActions(['setReadyToPayBill']),
    changeElectricName() {
      this.form.electricName = this.form.electricName.trim();
    },
    changeElectricNumber() {
      this.form.electricNumber = this.formatedElectricNumber.trim().replace(/ /g, '');
      this.formatedElectricNumber = this.formatElectricNumber(this.form.electricNumber);      
    },
    getFavoriteElectrics() {
      queryFavoriteElectricNumber().then((res) => {
        if (res.error === undefined) {
          this.favoriteElectricList = res.electricity_number_list;
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    addFavoriteElectricNumber() {
      var form = {
        electricity_number: this.form.electricNumber,
        electricity_name: this.form.electricName,
      };
      if (this.isAddFavroriteChecked) {
        saveFavoriteElectricNumber(form).then((res) => {
          if (res.error !== undefined) {
            alert(res.error.message);
          } else {
            this.getBillIsNull(false, form.electricity_name, form.electricity_number);
          }
        });
      } else {
        this.getBillIsNull(false, form.electricity_name, form.electricity_number);
      }
    },
    formatElectricNumber(electricNumber) {
      var formatedtElectricNumber = '';
      var index = 0;
      if (electricNumber.length > 2) {
        formatedtElectricNumber += (electricNumber.substr(0,2) + ' ');
        index = 2;
      }
      if (electricNumber.length > 4) {
        formatedtElectricNumber += (electricNumber.substr(2,2) + ' ');
        index = 4;
      }
      if (electricNumber.length > 8) {
        formatedtElectricNumber += (electricNumber.substr(4,4) + ' ');
        index = 8;
      }
      if (electricNumber.length > 10) {
        formatedtElectricNumber += (electricNumber.substr(8,2) + ' ');
        index = 10;
      }
      formatedtElectricNumber += electricNumber.substr(index);
      return formatedtElectricNumber;
    },
    
    getBillIsNull(isScanning, electricName, electricNumber) {
      var form = {
        payment_item_id: 'TWNCH-0101',
        payment_query_type: isScanning ? 'REALTIME-2' : 'REALTIME-1',
        parameter1: isScanning ? this.form.qrCode : electricNumber,
        parameter2: isScanning ? '' : electricName,
        parameter3: '',
        payment_custom_id: '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          this.setReadyToPayBill(res);
          this.$router.push({
            path: '/goPay',
            query: {
              payment_item_id: 'TWNCH-0101',
              parameter1: isScanning ? this.form.qrCode : electricNumber,
              parameter2: isScanning ? '' : electricName,
              parameter3: '',
              payment_query_type: form.payment_query_type,
            },
          });        
        } else {
          alert(res.error.message);
        }
        if (this.isAddFavroriteChecked) {
          this.getFavoriteElectrics();
        }
      });
    },
    removeFavoriteElectricNumber(electricSerialNumber) {
      if (confirm('確定要刪除？')) {
        deleteFavoriteElectricNumber({ electricity_number_serial_number: electricSerialNumber }).then((res) => {
          if (res.error === undefined) {
            this.isListInModify = false;
            this.getFavoriteElectrics();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    openScanner() {
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 4 },
      });
    },
    getScanningResult(paymentCustomId) {
      this.form.qrCode = paymentCustomId;
      this.getBillIsNull(true, '', '');
    },
  
    changeIDNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (e.target.value.length >= 11) {
        e.target.blur();
      }
    },
  },
  watch: {
    
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.border {
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
  padding: 9pt 0;
}

.field {
  font-size: 14px;
}

.form {
  margin: 24pt 0;
}

.border-bottom {
  margin-bottom: 24pt;
}
</style>
